import { Consent, DigitalGpSubmission } from '@sky-distribution/digital-gp-submission';
import { mapConsentsByStatus } from '@sky-distribution/gp-onboarding-shared-utils';

export const getSubmissionWithConsents = (
  submission: DigitalGpSubmission,
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
): DigitalGpSubmission => ({
  ...submission,
  baseData: {
    ...submission.baseData,
    consents_SKY: mapConsentsByStatus(consentStatus, consentDictionary),
  },
});
